import * as React from 'react';
import { connect } from 'react-redux';
import { IPaymentDetails } from '../CustomTypes';
import {
  Address,
  BirthDate,
  Button,
  Email,
  InputField,
  MobileNumber,
  Name,
  PaymentMethods
} from '../input-components/InputComponents';
import FooterSameLoginAsOthers from '../layout-components/FooterSameLoginAsOthers';
import LoadMask from '../layout-components/LoadMask';
import { validateName } from '../validators';
import './Components.scss';

export interface IState {
  paymentMethods: Array<{
    id: number;
    details: {
      maskedNumber: string;
      paymentMethod: string;
      expiryDate: { year: number; month: number; day: number };
    };
  }>;
  selectedPaymentMethod: number;
  normalEmail: string;
  validEmail: string;
  invalidEmail: string;
}

export class Components extends React.Component<{}, IState> {
  constructor(props: {}) {
    super(props);
    this.changePaymentMethod = this.changePaymentMethod.bind(this);
    this.state = {
      invalidEmail: 'not valid',
      normalEmail: '',
      paymentMethods: this.createPaymentMethods(),
      selectedPaymentMethod: 1,
      validEmail: 'test@test.com'
    };
  }

  public render() {
    return (
      <div className="components">
        <div className="container">
          <div className="row mask">
            <div className="col-xs-12">
              <div className="paragraf">
                <p>Headers</p>
              </div>
              <h1>Heading test h1</h1>
              <h2>Heading test h2</h2>
              <h3>Heading test h3</h3>
              <h4>Heading test h4</h4>
              <p>Paragraph text</p>
            </div>

            <div className="col-xs-12">
              <div className="paragraf">
                <p>Input fields</p>
              </div>
              <Email />
              <MobileNumber />
              <Name />

              <InputField
                label="Disabled"
                disabled={true}
                value={'Cant be changed'}
                placeholder=""
                validator={validateName}
              />
              <div className="space10px" />
            </div>

            <div className="col-xs-12">
              <div className="paragraf">
                <p>Fødselsdato</p>
              </div>
              <BirthDate />
            </div>
            <div className="col-xs-12">
              <div className="paragraf">
                <p>Addresse</p>
              </div>
            </div>
            <Address />

            <div className="col-xs-12">
              <div className="paragraf">
                <p>Kredittkort</p>
              </div>
              <PaymentMethods
                paymentMethods={this.createPaymentMethods()}
                selectedPaymentMethodId={this.state.selectedPaymentMethod}
                setSelectedPaymentMethod={this.changePaymentMethod}
              />
            </div>

            <div className="col-xs-12">
              <div className="paragraf">
                <p>Messages</p>
              </div>
              <div>
                <div className="alert alert-info">Alert info</div>
                <div className="alert alert-warning">Alert warning</div>
                <div className="alert alert-validation">Alert validation</div>
                <div className="alert alert-error">Alert error</div>
              </div>
            </div>

            <div className="col-xs-12">
              <div className="paragraf">
                <p>Buttons</p>
              </div>
              <div className="row">
                <Button>Button</Button>
              </div>
              <div className="row">
                <Button disabled={true}>Button disabled</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row spinnertest">
          <LoadMask />
        </div>

        <FooterSameLoginAsOthers />
      </div>
    );
  }

  private createPaymentMethods() {
    const card1 = {
      details: {
        expiryDate: { year: 2017, month: 4, day: 1 },
        maskedNumber: '************0123',
        paymentMethod: 'MC'
      },
      id: 1
    };
    const card2 = {
      details: {
        expiryDate: { year: 2019, month: 1, day: 1 },
        maskedNumber: '************0123',
        paymentMethod: 'VISA'
      },
      id: 2
    };
    return [card1, card2];
  }

  private changePaymentMethod(e: IPaymentDetails) {
    this.setState({ selectedPaymentMethod: e.id });
  }
}

export default connect()(Components);



// WEBPACK FOOTER //
// ./src/page-components/Components.tsx